// =================================================================
// IndexedDB via Dexie — cache offline del TPV
// =================================================================
//
// Pequeña BD local en el navegador. La usamos como fallback cuando
// el Bridge no está accesible y la red está caída: pintar el catálogo
// para no quedarse el TPV en blanco.
//
// Las VENTAS no van aquí — eso es responsabilidad del Bridge cuando
// implementemos Fase 4.2 (outbox real). El TPV sin Bridge en LAN
// tampoco debe registrar ventas localmente porque pertenecen al
// establecimiento, no al dispositivo.

import Dexie, { type EntityTable } from 'dexie';
import type { CatalogSnapshot } from '@positec/api-client';

interface CachedSnapshot {
  id: 1;
  snapshot: CatalogSnapshot;
  fetched_at: string; // ISO
  cloud_url: string;
}

class PositecPosDb extends Dexie {
  catalog!: EntityTable<CachedSnapshot, 'id'>;

  constructor() {
    super('positec_pos');
    this.version(1).stores({
      catalog: 'id',
    });
  }
}

const db = new PositecPosDb();

export async function saveCatalogToCache(
  snapshot: CatalogSnapshot,
  cloudUrl: string,
): Promise<void> {
  try {
    await db.catalog.put({
      id: 1,
      snapshot,
      fetched_at: new Date().toISOString(),
      cloud_url: cloudUrl,
    });
  } catch (e) {
    console.warn('[positec] no se pudo cachear catálogo en IndexedDB', e);
  }
}

export async function loadCatalogFromCache(): Promise<{
  snapshot: CatalogSnapshot;
  fetched_at: string;
} | null> {
  try {
    const row = await db.catalog.get(1);
    if (!row) return null;
    return { snapshot: row.snapshot, fetched_at: row.fetched_at };
  } catch (e) {
    console.warn('[positec] no se pudo leer catálogo de IndexedDB', e);
    return null;
  }
}

export async function clearCatalogCache(): Promise<void> {
  try {
    await db.catalog.clear();
  } catch {
    /* ignore */
  }
}
